<template>
    <header class="header">
        <div class="top-nav">
            <div class="logo">
                <img v-if="locale !== 'zh'" src="@/assets/logo.png" alt="Kooyii Logo" />
                <img v-else src="@/assets/jianshu.png" alt="Kooyii Logo" />
            </div>
            <nav class="nav-links">
                <router-link :to="item.path" v-for="(item, index) in navItems" :key="index"
                    :class="{ 'active-link': activeNavIndex === index }" @click.prevent="setActiveNav(index)">
                    {{ t(`nav.${item.key}`) }}
                </router-link>
            </nav>
            <div class="nav-actions">
                <div class="lang-selector" @click.stop="toggleLangDropdown">
                    <span class="current-lang">
                        <svg t="1785143888093" class="icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="1873" width="20" height="20">
                            <path
                                d="M848.805886 805.572222c70.998007-81.260745 109.779266-184.217628 109.779266-293.14448 0-119.204939-46.421262-231.277434-130.713041-315.569212C744.876861 113.862257 634.94103 67.61598 517.788843 66.213028c-1.924839-0.599657-10.290367-0.592494-12.227486 0.01535C388.878868 67.945485 279.434224 114.159016 196.73471 196.85853 113.863281 279.730982 67.630307 389.460106 66.095347 506.415818c-0.428765 1.64957-0.436952 8.601912-0.021489 10.226922 1.082658 117.628024 47.364751 228.058113 130.660852 311.354214 84.291778 84.291778 196.36325 130.713041 315.569212 130.713041 119.204939 0 231.277434-46.421262 315.569212-130.713041 6.139837-6.139837 12.054547-12.444427 17.789155-18.871813 0.50756-0.453325 1.001817-0.928139 1.471514-1.440815C847.750857 807.012014 848.295256 806.299793 848.805886 805.572222zM107.447151 532.043499l187.501418 0c1.322112 65.678862 9.253758 127.264499 22.505573 182.112688-61.690014 16.687054-100.819197 38.371936-121.076566 51.906184C144.30971 701.336206 111.676475 620.35687 107.447151 532.043499zM195.881272 259.408121c20.090571 13.556761 59.242266 35.461653 121.340579 52.260248-12.998035 54.127781-20.827351 114.778116-22.243607 179.432649L107.525945 491.101018C112.076588 403.731134 144.437623 323.612399 195.881272 259.408121zM917.081898 491.099994 729.628576 491.099994c-1.415232-64.630996-9.240455-125.260865-22.229281-179.37432 61.95505-16.693194 101.235682-38.444591 121.56673-52.020794C880.270505 323.860039 912.537396 403.866211 917.081898 491.099994zM688.677908 491.099994 532.167319 491.099994 532.167319 335.061149c52.209082-1.094938 97.103572-6.453992 135.272893-14.033621C680.000272 373.163955 687.286212 430.896844 688.677908 491.099994zM532.167319 294.115598 532.167319 109.918435c36.84107 10.398838 72.779583 49.205679 100.926644 110.015649 8.810666 19.035542 16.645099 39.641859 23.464411 61.521169C621.531626 288.227494 580.261687 293.062616 532.167319 294.115598zM491.223814 110.273523l0 183.805236c-47.504944-1.12666-88.378863-6.001691-123.120109-12.802584 6.807033-21.812795 14.623046-42.35976 23.409153-61.344137C419.351903 159.792333 454.809463 121.175827 491.223814 110.273523zM491.223814 335.040682l0 156.059312L335.928912 491.099994c1.391696-60.213383 8.679683-117.955482 21.243837-170.099073C395.008472 328.536548 439.487499 333.887416 491.223814 335.040682zM335.893096 532.043499l155.330718 0 0 158.667719c-51.609425 1.194198-96.019891 6.563486-133.821845 14.103206C344.576873 651.927913 337.193719 593.243349 335.893096 532.043499zM491.223814 731.672118l0 182.909843c-36.415374-10.902304-71.871911-49.51881-99.709933-109.659539-8.679683-18.752086-16.409738-39.034015-23.157419-60.551074C402.9964 737.645157 443.773106 732.820268 491.223814 731.672118zM532.167319 914.937049 532.167319 731.608673c47.904033 1.025353 89.103364 5.862521 124.116809 12.656251-6.755868 21.555945-14.497179 41.87369-23.190165 60.656475C604.946902 865.73137 569.008388 904.538211 532.167319 914.937049zM532.167319 690.660052 532.167319 532.043499l156.546406 0c-1.298576 61.096497-8.66024 119.68487-21.445428 172.502819C629.154233 697.013761 584.319096 691.710988 532.167319 690.660052zM729.659275 532.043499l187.501418 0c-4.221138 88.138386-36.732599 168.973436-88.620363 233.635131-20.469194-13.668301-59.635215-35.298947-121.30374-51.868321C720.43724 659.049101 728.33921 597.585237 729.659275 532.043499zM801.518906 228.742704c-18.329461 11.570523-52.309366 29.355585-104.858186 43.493583-19.295462-63.056128-46.110177-115.004267-78.06189-150.97655C689.00025 140.410913 751.833297 178.097234 801.518906 228.742704zM406.007991 121.259738c-31.905664 35.920094-58.690704 87.768973-77.979002 150.702304-52.40351-14.241352-86.370113-32.099069-104.581893-43.587728C273.076422 177.914062 335.777463 140.364865 406.007991 121.259738zM223.917816 796.963147c18.284435-11.535731 52.098565-29.230742 104.332207-43.335994 19.271926 62.60485 45.976124 114.186645 77.757968 149.968593C335.99952 884.550994 273.472442 847.181899 223.917816 796.963147zM618.59883 903.595746c31.801287-35.803437 58.517765-87.426165 77.792761-150.08218 51.984978 14.023388 85.972047 31.631418 104.533798 43.208081C751.3329 847.061149 688.718841 884.521319 618.59883 903.595746z"
                                fill="#1a1a1a" p-id="1874"></path>
                        </svg>
                        {{ currentLangName }}
                        <svg v-if="!showLangDropdown" t="1785144487239" class="icon" viewBox="0 0 1024 1024"
                            version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2837" width="15" height="15">
                            <path
                                d="M512 704c8.288 0 15.776-3.232 21.456-8.4l0.064 0.08 352-320-0.08-0.08c6.448-5.856 10.56-14.208 10.56-23.6a32 32 0 0 0-32-32c-8.288 0-15.76 3.232-21.456 8.4l-0.08-0.08L512 628.752 181.536 328.32l-0.08 0.08A31.776 31.776 0 0 0 160 320a32 32 0 0 0-32 32c0 9.376 4.112 17.744 10.544 23.6l-0.08 0.08 352 320 0.08-0.08c5.68 5.168 13.168 8.4 21.456 8.4z"
                                fill="#1a1a1a" p-id="2838"></path>
                        </svg>
                        <svg v-else t="1785144997120" class="icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="1329" width="15" height="15">
                            <path
                                d="M512 320c-8.288 0-15.776 3.232-21.456 8.4l-0.064-0.08-352 320 0.08 0.08C132.112 654.256 128 662.608 128 672a32 32 0 0 0 32 32c8.288 0 15.76-3.232 21.456-8.4l0.08 0.08L512 395.248 842.464 695.68l0.08-0.08A31.776 31.776 0 0 0 864 704a32 32 0 0 0 32-32c0-9.376-4.112-17.744-10.544-23.6l0.08-0.08-352-320-0.08 0.08c-5.68-5.168-13.168-8.4-21.456-8.4z"
                                fill="#1a1a1a" p-id="1330"></path>
                        </svg>
                    </span>

                    <!-- 下拉菜单 -->
                    <transition name="dropdown">
                        <ul v-show="showLangDropdown" class="lang-dropdown">
                            <li v-for="lang in languages" :key="lang.code" @click.stop="selectLanguage(lang)"
                                :class="{ active: currentLangCode === lang.code }">
                                {{ lang.nativeName }}
                            </li>
                        </ul>
                    </transition>
                </div>
            </div>
        </div>
    </header>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'

import { useI18n } from 'vue-i18n'

const { t, locale } = useI18n()

// =========================================
// 1. 导航菜单状态管理
// =========================================

const route = useRoute()

// 1. 导航项配置，绑定对应的路由 path
const navItems = ref([
    { key: 'home', path: '/' },
    { key: 'products', path: '/products' },
    { key: 'solutions', path: '/solutions' },
    // { key: 'support', path: '/support' },
    { key: 'contact', path: '/contact' }
])

const activeNavIndex = ref(0)

// 3. 菜单点击处理逻辑
const setActiveNav = (index) => {
    activeNavIndex.value = index
}
// ✨ 4. 自动高亮同步：当页面路由改变时（包括浏览器前进/后退/直接刷页），自动匹配当前高亮
watch(
    () => route.path,
    (newPath) => {
        const matchedIndex = navItems.value.findIndex(item => item.path === newPath)
        if (matchedIndex !== -1) {
            activeNavIndex.value = matchedIndex
        }
    },
    { immediate: true } // 页面加载时立即执行一次
)


// =========================================
// 2. 多语言下拉框状态管理 (完全封装在组件内部)
// =========================================
const showLangDropdown = ref(false)
const currentLangCode = computed(() => locale.value)

const languages = ref([
    { code: 'en', nativeName: 'English' },
    { code: 'fr', nativeName: 'Français' },
    { code: 'ru', nativeName: 'Русский' },
    { code: 'es', nativeName: 'Español' },
    { code: 'it', nativeName: 'Italiano' },
    { code: 'zh', nativeName: '中文' },
    { code: 'pt', nativeName: 'Português' },
    { code: 'pt-br', nativeName: 'Português (Brasil)' }
])

const currentLangName = computed(() => {
    const lang = languages.value.find(l => l.code === currentLangCode.value)
    return lang ? lang.nativeName : 'English'
})

const toggleLangDropdown = () => {
    showLangDropdown.value = !showLangDropdown.value
}

const selectLanguage = (lang) => {
    // 1. 切换你的语言状态 (如果接入了 vue-i18n 就是 locale.value = lang.code)
    locale.value = lang.code;

    // ✨ 2. 关键：选择完毕后，将下拉框的显示状态置为 false
    showLangDropdown.value = false;

    // (可选) 持久化存储用户的选择
    localStorage.setItem('user-locale', lang.code);
}

const closeDropdown = (e) => {
    if (!e.target.closest('.lang-selector')) {
        showLangDropdown.value = false
    }
}

// 页面加载时读取缓存的语言设置
onMounted(() => {
    const savedLocale = localStorage.getItem('user-locale')
    if (savedLocale) {
        locale.value = savedLocale
    }
    document.addEventListener('click', closeDropdown)
})

onUnmounted(() => {
    document.removeEventListener('click', closeDropdown)
})


</script>

<style lang="css" scoped>
/* =========================================
   以下为页面布局 CSS (与上一版基本一致)
   ========================================= */
.logo {
    display: flex;
    align-items: center;
    cursor: pointer;
    /* 鼠标放上去变小手，通常 logo 点击会回首页 */
}

/* ✨ 控制图片的尺寸 ✨ */
.logo img {
    height: 40px;
    /* 请根据你导航栏的实际情况微调这个高度（一般 30px - 50px 比较合适） */
    width: auto;
    /* 宽度设为 auto，让图片按原比例缩放，不会变形 */
    object-fit: contain;
}

.current-lang {
    display: flex;
    align-items: center;
    /* ✨ 核心：让内部所有元素垂直居中 */
    gap: 6px;
    /* ✨ 可选：统一设置图标和文字之间的间距，替代 margin */
    cursor: pointer;
}

/* 确保 SVG 有明确的尺寸 */
.globe-icon {
    width: 16px;
    height: 16px;
    display: block;
    /* 防止 SVG 底部产生默认的幽灵空白 */
    fill: currentColor;
    /* 让 SVG 颜色自动跟随父元素的文字颜色 */
}

.header {
    /* ✨ 核心：固定在顶部 ✨ */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    /* 必须设置 100%，否则 fixed 后会收缩 */
    z-index: 999;
    /* 确保层级最高，滚动时盖住下方所有内容 */

    /* 基础视觉样式 */
    background: #ffffff;
    border-bottom: 1px solid #eaeaea;

    /* ✨ 推荐：加一个轻微的阴影，当页面往下滚时，导航栏和页面有更好的立体层次感 ✨ */
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.top-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 40px;
    color: #2a2a2a;
}

/* 导航容器 */
.nav-links {
    display: flex;
    gap: 100px;
    /* 统一控制菜单间距 */
    align-items: center;
}

/* 导航链接基础样式 */
.nav-links a {
    color: #2a2a2a;
    /* color: #e5e5e5; */
    /* 默认文字颜色稍微暗一点 */
    text-decoration: none;
    font-size: 0.95rem;
    font-weight: 500;
    position: relative;
    padding-bottom: 6px;
    /* 给底部的下划线留出空间 */
    transition: color 0.3s ease;
}

/* 鼠标悬浮时的文字变色 */
.nav-links a:hover {
    color: #0987fc;
}

/* ✨ 核心：下划线伪元素初始化 ✨ */
.nav-links a::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    /* 从中间开始扩散 */
    width: 0;
    /* 默认宽度为0，不显示 */
    height: 2px;
    /* 下标线的粗细 */
    background-color: #0987fc;
    /* 下标线的颜色，可以根据你的主题色修改，比如 #409eff */
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    transform: translateX(-50%);
    /* 配合 left: 50% 保证从中心向两边展开 */
    border-radius: 2px;
    /* 线条两端圆角，更精致 */
}

/* ✨ 激活状态 & 鼠标悬浮状态：下划线展开 ✨ */
.nav-links a.active-link::after,
.nav-links a:hover::after {
    width: 100%;
    /* 宽度占满文字区域 */
}

/* 激活状态的文字样式 */
.nav-links a.active-link {
    color: #0987fc;
    font-weight: 600;
    /* 当前选中的菜单稍微加粗 */
}

.lang-selector {
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
}

/* ✨ 关键点 2：下拉菜单必须是绝对定位 ✨ */
.lang-dropdown {
    position: absolute;
    top: 100%;
    /* 紧贴在父容器底部 */
    right: 0;
    /* 下拉框右侧与父容器右侧对齐 */
    margin-top: 10px;
    /* 稍微往下偏移一点点，留出呼吸感 */
    z-index: 9999;
    /* 确保层级最高，绝对不会被下面的内容遮盖 */

    /* 视觉样式优化 */
    background-color: #ffffff;
    /* 配合你深色的 Header */
    color: #2a2a2a;
    min-width: 150px;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);

    /* ✨ 关键点 3：清除 ul 默认的圆点和内边距 ✨ */
    list-style: none;
    padding: 8px 0;
}

/* 下拉菜单内的选项样式 */
.lang-dropdown li {
    padding: 10px 20px;
    transition: background-color 0.2s;
    white-space: nowrap;
    /* 防止语言名字换行 */
}

.lang-dropdown li:hover {
    background-color: #444;
    color: #ffffff;
    /* 悬浮时的反馈底色 */
}
</style>